import { SVGAttributes } from 'react'

export function StopAlertIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 72 72" fill="currentColor" {...props}>
      <path d="M66.15 21.6L50.4 5.85C49.5 4.95 48.375 4.5 47.25 4.5H24.75C23.625 4.5 22.5 4.95 21.6 5.85L5.85 21.6C4.95 22.5 4.5 23.625 4.5 24.75V47.25C4.5 48.375 4.95 49.5 5.85 50.4L21.6 66.15C22.5 67.05 23.625 67.5 24.75 67.5H47.25C48.375 67.5 49.5 67.05 50.4 66.15L66.15 50.4C67.05 49.5 67.5 48.375 67.5 47.25V24.75C67.5 23.625 67.05 22.5 66.15 21.6ZM63 47.25L47.25 63H24.75L9 47.25V24.75L24.75 9H47.25L63 24.75V47.25ZM38.25 42.75H33.75V18H38.25V42.75ZM39.375 50.625C39.375 52.425 37.8 54 36 54C34.2 54 32.625 52.425 32.625 50.625C32.625 48.825 34.2 47.25 36 47.25C37.8 47.25 39.375 48.825 39.375 50.625Z" />
    </svg>
  )
}
